import React, { useEffect, useState } from "react";
import { api, apiJson } from "@/api/client.js";
import { FacebookImportPanel } from "@/pages/FacebookImportPanel.jsx";
import { ReconstructionPage } from "@/pages/ReconstructionPage.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function AdminPage() {
  const { ui } = useOrignalUi();
  const [sys, setSys] = useState(null);
  const [first, setFirst] = useState("");
  const [mod, setMod] = useState("rebuild");
  useEffect(() => {
    api("/api/admin/system").then(setSys).catch(() => {});
  }, []);
  return (
    <main className="og-page" data-testid="page-admin">
      <h1>{ui.admin.title}</h1>
      <p className="og-lead">{ui.admin.subtitle}</p>
      <div className="og-chips">
        <button type="button" className={`og-chip${mod === "rebuild" ? " is-active" : ""}`} onClick={() => setMod("rebuild")} data-testid="admin-mod-rebuild">{ui.rebuild.title}</button>
        <button type="button" className={`og-chip${mod === "facebook" ? " is-active" : ""}`} onClick={() => setMod("facebook")} data-testid="admin-mod-facebook">{ui.fbImport.title}</button>
        <button type="button" className={`og-chip${mod === "system" ? " is-active" : ""}`} onClick={() => setMod("system")}>{ui.admin.system}</button>
      </div>
      {mod === "system" ? (
        <>
          <dl className="og-meta">
            <dt>{ui.settings.version}</dt><dd>{sys?.health?.semver}</dd>
            <dt>{ui.settings.env}</dt><dd>{sys?.health?.env}</dd>
            <dt>{ui.settings.commit}</dt><dd>{sys?.health?.commit}</dd>
          </dl>
          <form className="og-inline" onSubmit={async (e) => { e.preventDefault(); await apiJson("/api/admin/members", { first_name: first }); setFirst(""); }}>
            <input className="og-input" value={first} onChange={(e) => setFirst(e.target.value)} placeholder={ui.admin.invite} />
            <button className="og-btn og-btn--primary" type="submit">{ui.admin.invite}</button>
          </form>
        </>
      ) : mod === "rebuild" ? (
        <ReconstructionPage />
      ) : (
        <FacebookImportPanel />
      )}
    </main>
  );
}
